module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_4.dfbedfa7.jpg";